import axios from 'axios';

import {
	getStoredRoleData,
	getStoredTokenData
} from '../store/auth-context';

import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_WS_URL;

export const sendInfoChat = async (options, chatId) => {
	const token = getStoredTokenData().token;
	console.log(options, 'options', chatId, 'chat')
	return await axios.post(`${API_URL}/api/chatbot/send-notification`, { options, chatId },{
		headers: {
			token: `${token}`
		}
	});
};

export const getInfoChat = async (chatId) => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/chatbot/get-notification/?${chatId}`, {
		headers: {
			token: `${token}`
		}
	});
};

export const getChatsList = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/chatbot/get-new-chats/`, {
		headers: {
			token: `${token}`
		}
	});
};

export const getChatsListParameters = async (lastCheck) => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/chatbot/get-new-chats/?${lastCheck}`, {
		headers: {
			token: `${token}`
		}
	});
};

